import {
  BOOK_COMPONENT_CATEGORY_IDS,
  HARDWARE_PRODUCT_TYPE_ID,
} from "constants/config";

export const getOrderShippingAddress = (order) =>
  order?.addressDetails?.shippingAddress ||
  order?.shippingAddress ||
  order?.addressDetails?.shipping_address ||
  order?.shipping_address ||
  null;

export const orderHadShippingAddress = (order) => {
  const shipping = getOrderShippingAddress(order);
  if (!shipping || typeof shipping !== "object") {
    return false;
  }

  return Boolean(
    shipping.addressLine1 ||
      shipping.address_line_1 ||
      shipping.city ||
      shipping.recipientName ||
      shipping.recipient_name ||
      shipping.postalCode ||
      shipping.postal_code ||
      shipping.district
  );
};

export const cartRequiresShippingAddress = (
  selectedPackageSubscriptions = []
) =>
  selectedPackageSubscriptions.some(
    (pkg) =>
      (pkg.componentProductTypeIds || []).includes(HARDWARE_PRODUCT_TYPE_ID) ||
      (pkg.componentCategoryIds || []).some((categoryId) =>
        BOOK_COMPONENT_CATEGORY_IDS.includes(categoryId)
      )
  );

export const resolveRequiresShippingAddress = (
  selectedPackageSubscriptions,
  previousOrderHadShipping = false
) =>
  cartRequiresShippingAddress(selectedPackageSubscriptions) ||
  Boolean(previousOrderHadShipping);

export const mapCapturedAddressToForm = (address) => {
  if (!address) {
    return {};
  }
  return {
    recipientName: address.recipientName ?? address.recipient_name,
    parentName: address.parentName ?? address.parent_name,
    recipientPhoneNumber: address.maskedPhoneNo ?? address.masked_phone_no,
    recipientEmail: address.email,
    addressLine1: address.addressLine1 ?? address.address_line_1,
    addressLine2: address.addressLine2 ?? address.address_line_2,
    street: address.street,
    city: address.city,
    district: address.district,
    state: address.state,
    pincode: address.postalCode ?? address.postal_code,
    landmark: address.landmark,
  };
};
